//codex-- Style navigation at the page boundary.
import PageToolbar from './PageToolbar';
import React, { useState, useEffect } from 'react';
import BuilderEstimateTabs from '../components/BuilderEstimateTabs';
import EstimateBar from '../components/EstimateBar';
import { useParams } from 'react-router-dom';
import HeadingCp from '../components/HeadingCp';
import BuilderEquipmentCp from '../components/BuilderEquipmentCp';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const BuilderEquipment = () => {
  const { id, key } = useParams();
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [equipmentCategories, setEquipmentCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  // activeTab is the equipment_category string
  const [activeTab, setActiveTab] = useState(null);
  // selectedCategory is the numeric id of whichever tab was clicked last
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(`${apiUrl}/best_crud.php`, {
          params: {
            estimate: id,
            builder_id: key,
            getEquipmentBuilder: key
          }
        });
        console.log(data);
        
        if (data[0] === 'success') {
          setEquipmentCategories(data[1] || []);
          // default to the first non-Add-On
          const mains = data[1].filter(t => !t.equipment_category.startsWith('Add-On'));
          if (mains.length) {
            setActiveTab(mains[0].equipment_category);
            setSelectedCategory(mains[0].id);
          }
        }
      } catch (err) {
        // …your error handling…
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [apiUrl, id, key, navigate]);

  if (loading) return <div>Loading…</div>;

  // 1) top-level tabs
  const mainTabs = equipmentCategories.filter(
    t => !t.equipment_category.startsWith('Add-On')
  );
  // 2) any Add-On tabs matching the activeTab
  const addOnTabs = equipmentCategories.filter(
    t => t.equipment_category === `Add-On ${activeTab}`
  );

  const onTabSelect = (tab) => {
    setActiveTab(tab.equipment_category);
    setSelectedCategory(tab.id);
  };

  return (
    <div className="mx-auto max-w-[1200px] p-8 bg-white">
      <EstimateBar id={id} name="Equipment" builder_id={key}/>
      <HeadingCp label="Equipments" />

      {/* Top‐level */}
      <>{/* //codex-- Present existing page navigation in the shared toolbar header. */}<PageToolbar title="Page navigation" actions={<BuilderEstimateTabs
        tabs={mainTabs}
        active={activeTab}
        onTabSelect={onTabSelect}
      />} /></>

      {/* nested “Add-On X” under X */}
      {addOnTabs.length > 0 && (
        <div className="pl-6 border-l border-gray-500 mt-2 bg-gray-50 text-blue-800">
          <>{/* //codex-- Present existing page navigation in the shared toolbar header. */}<PageToolbar title="Page navigation" actions={<BuilderEstimateTabs
            tabs={addOnTabs}
            active={activeTab}
            onTabSelect={onTabSelect}
          />} /></>
        </div>
      )}

      {/* finally – your actual device list for selectedCategory */}
      <BuilderEquipmentCp
        titleLeft="Components"
        titleRight="Selected Equipments"
        categoryId={selectedCategory}
      />
    </div>
  );
};

export default BuilderEquipment;
